/*基础配置*/
//导入基础插件
import Vue from 'vue';
//浏览器补全promise api
require('es6-promise').polyfill();
// import 'static/config.js'
//引入 ui
import './config/ui-config.js'
//引入 插值过滤器 
import './config/filter-config.js'
// 引入 全局组件
import "./config/global-component.js"
// 引入 axios
import {instance} from './config/axiosConfig.js';
Vue.prototype.$http = instance;


// 公共函数
import func,{ insertAfter,successTip,errorTip  } from 'src/control/common.js';  //公共方法
Vue.prototype.$func = func;
Vue.prototype.successTip = successTip;
Vue.prototype.errorTip = errorTip;

// 引入 加密/解密 模块
import crypto from './control/crypto.js'
Vue.prototype.$crypto = crypto;

// 引入消息系统对象
import InfoSystem from './control/info/main.js'
Vue.prototype.$infoSystem = InfoSystem;

// 引入表单验证 模块
import check from "src/control/formCheck.js"
// 引入 路由
import router from "src/control/main-router.js";

Vue.prototype.$form = check;
check.router = router;  //把路由塞到form对象里

let windowPop = (function(){  //离开页面的遮罩
    let cache = {only:""};
    let app; 
    // setTimeout(()=>{
    //     app = document.getElementById("app");
    // },0); 

    let constructor = function(name){
        set.call(this,name);
        bind.call(this);
    }

    function set(name){  //分配私有属性
        this.el = getPop.call(this,name);
        this.cancel = this.el.getElementsByClassName("cancel")[0];
        this.cancel2 = this.el.getElementsByClassName("el-icon-close")[0];
        this.leave = this.el.getElementsByClassName("leave")[0];
    }

    function bind(){  //绑定行为
        let _pop = this;
        this.el.onclick = function(e){
            if(e.target === this){
                _pop.hide();
            }
        }

        this.cancel.onclick = _pop.hide.bind(this);
        this.cancel2.onclick = _pop.hide.bind(this);
        this.leave.onclick = function(){
            _pop.hide();
            setTimeout(()=>{
                _pop.func && _pop.func();
            },300);
        }
    }   

    function getPop(name){
        name = name || "only";
        this.name = name;
        if(cache[name]){
            return cache[name];
        }
        return createPop(name);
    }

    function createPop(name){
        let divDom = document.createElement("div");
        divDom.className = "z-window";
        divDom.innerHTML=
        `<div class="main">
            <div class="head"><i>警告</i><i class="el-icon-close"></i></div>
            <div class="text">离开该页面后，将不保存你更改的内容</div>
            <div class="btns">
                <div class="btn leave">离开</div>
                <div class="btn cancel">留下</div>
            </div>
         </div>`;
        app = app || document.getElementById("app");
        insertAfter(divDom,app);
        cache[name] = divDom;
        return divDom;
    }

    constructor.prototype = {
        show(){
            this.el.style.display = "block";
            setTimeout(()=>{
                this.el.classList.add("active");
            },0);
        },
        hide(){
            console.log("消失了");
            this.el.classList.remove("active");
            setTimeout(()=>{
                this.el.style.display = "none";
            },500);
        },
    }

    return constructor;
})();


//导入vuex数据
import store from './store'
//导入组件
import App from './App'


let vm = new Vue({
    el: '#app',
    router, 
    store,
    template: '<App/>',
    components: { App }
});

check.window_pop = new windowPop();


// WEBPACK FOOTER //
// ./src/main.js